export const MODAL_TYPES = {
  INIT_APP: 'INIT_APP',
  BACKEND_DOWN: 'BACKEND_DOWN',
  USER_OFFLINE: 'USER_OFFLINE',
  DIGITAL_ASSET_UPLOAD: 'DIGITAL_ASSET_UPLOAD',
  DIGITAL_ASSET_PREVIEW: 'DIGITAL_ASSET_PREVIEW',
  DIGITAL_ASSET_EXISTING: 'DIGITAL_ASSET_EXISTING',
  XML_PREVIEW_MODAL: 'XML_PREVIEW_MODAL',
};
